import React from 'react';
import Drawer from './Drawer';
import { drawerStore } from './DrawerStore';
import { observer } from 'mobx-react';

function DrawerContainer({ id }) {
	const matchesContainer = Array.isArray(drawerStore.containerId)
		? drawerStore.containerId.includes(id)
		: drawerStore.containerId === id;

	if (!matchesContainer) {
		return null;
	}

	const handleClickClose = () => {
		drawerStore.closeDrawer();
	};

	return (
		<div
			className={`drawer-container ${drawerStore.drawerId || ''}${
				drawerStore.isClosing ? ' is-closing' : ''
			}`}>
			<Drawer
				title={drawerStore.title}
				customHeader={drawerStore.customHeader}
				showHeader={drawerStore.showHeader}
				onClose={handleClickClose}>
				{(drawerStore.isOpen || drawerStore.isClosing) &&
					drawerStore.drawerComponent &&
					React.createElement(
						drawerStore.drawerComponent,
						drawerStore.drawerComponentProps
					)}
			</Drawer>
		</div>
	);
}

export default observer(DrawerContainer);
